import React, { useState, useEffect, useRef} from 'react';
import { API } from 'aws-amplify';
import './FollowTheBeatModule6.css';
import { shallowEqual, useSelector, useDispatch} from 'react-redux';
import { getVideo } from '../s3Func/s3Download';
import PopUp from '../Popup/logoutPopup';
import LottieAnimation from '../components/Lottie/LottieAnimation';
import loading from './../loading-gif-png-5.gif';
import left from './left_hand.svg'
import right from './right_hand.svg'
/**
 *  Follow The Beat is an interactive module where kids tap objects flying into a circle at the specified time
 *  It involves a lot of timing and movement code, and while there are differences between the modules, Module6
 *  is the base for all of them and there should only be minor adjustments for each one.
 * @param {*} props
 * @returns The HTML code for Follow The Beat
 */
const FollowTheBeatModule6 = (props) => {
  // Initialize variables to be used later
  const dispatch = useDispatch();
  const lottieRef = useRef()
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const crab = generateImageUrl('images/Module1Images/Crab2.gif');
  const fish = generateImageUrl('images/Module6Images/Fish_Yellow%402x.png');
  const octopus = generateImageUrl('images/Module6Images/OctopusPlaceholder.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const coin = generateImageUrl('images/Images/Coin_Empty.png');

  const [playInstructions, setPlayInstructions] = useState(false);
  const [playSong, setPlaySong] = useState(false);
  const [song, setSong] = useState(props.song);
  const [playAwesomeJob, setPlayAwesomeJob] = useState(false);
  const [clappingAudio, setClappingAudio] = useState('');
  const [poppingAudio, setPoppingAudio] = useState('');
  const [showAnimal, setShowAnimal] = useState(false);
  const [tutorial, setTutorial] = useState(props.tutorial1);
  const [audioReady, setAudioReady] = useState(false);
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [animalGif, setAnimalGif] = useState(false);
  const [score, setScore] = useState(0);
  const [countGif, setCountingGif] = useState(props.count);
  const [coinAnimationState, setCoinAnimationState] = useState('');
  const [showCoin, setShowCoin] = useState(false);
  const [awesomeJobAudio, setAwesomeJobAudio] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [Exit, setExit] = useState(
    generateImageUrl('images/Images/close.png')
  );

  // Always-mounted audio refs/state
  const voiceAudioRef = useRef(null);
  const expectedVoiceSrcRef = useRef('');
  const voiceEndActionRef = useRef(null);
  const [voiceSrc, setVoiceSrc] = useState('');
  const [voiceShouldPlay, setVoiceShouldPlay] = useState(false);

  const musicAudioRef = useRef(null);
  const expectedMusicSrcRef = useRef('');
  const musicEndActionRef = useRef(null);
  const musicOnPlayActionRef = useRef(null);
  const [musicSrc, setMusicSrc] = useState('');
  const [musicShouldPlay, setMusicShouldPlay] = useState(false);

  const sfxAudioRef = useRef(null);
  const expectedSfxSrcRef = useRef('');
  const [sfxSrc, setSfxSrc] = useState('');
  const [sfxShouldPlay, setSfxShouldPlay] = useState(false);

  // This gets the gif for the crab to say "Awesome job"
  useEffect(() => {
    getGifs();
  }, []);
  function getGifs() {
    setAwesomeJobAudio(getVideo('appfiles/eye_contact/crab_awesome_job.mp3', login));
    setClappingAudio(getVideo('appfiles/ftb/single_clap.mp3', login));
    setPoppingAudio(getVideo('appfiles/ftb/bubble_pop.mp3', login));
  }

  // Toggles popups
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const playMusicAudio = async (src, onEndedAction = null, onPlayAction = null, restartIfSame = true) => {
    if (src && typeof src.then === 'function') src = await src;
    const el = musicAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedMusicSrcRef.current = src;
    musicEndActionRef.current = onEndedAction;
    musicOnPlayActionRef.current = onPlayAction;
    if (el && same) {
      if (!restartIfSame) return;
      try { el.pause(); el.currentTime = 0; await el.play(); } catch {}
    } else {
      setMusicSrc(src);
      setMusicShouldPlay(true);
    }
  };

  const playSfxAudio = async (src, restartIfSame = true) => {
    const el = sfxAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedSfxSrcRef.current = src;
    if (el && same) {
      if (!restartIfSame) return;
      try { el.pause(); el.currentTime = 0; await el.play(); } catch {}
    } else {
      setSfxSrc(src);
      setSfxShouldPlay(true);
    }
  };

  // The timing values. This denotes when the 1 bubble should hit the circle, and when the others should pop
  const timing = [
    {
      timestamp: 0,
    },
    {
      timestamp: 3.29,//1
    },
    {
      timestamp: 5.09,//2
    },
    {
      timestamp: 6.99,//3
    },
    {
      timestamp: 8.83,//4
    },
    {
      timestamp: 10.61,//1
    },
    {
      timestamp: 12.41,//2
    },
    {
      timestamp: 14.34,//3
    },
    {
      timestamp: 16.31,//4
    },
    {
      timestamp: 18.06,//1
    },
    {
      timestamp: 19.91,//2
    },
    {
      timestamp: 21.77,//3
    },
    {
      timestamp: 23.74,//4
    },
    {
      timestamp: 25.6,//1
    },
    {
      timestamp: 27.47,//2
    },
    {
      timestamp: 29.31,
    },
    {
      timestamp: 31.29,
    },
    {
      timestamp: 33.02,
    },
    {
      timestamp: 34.9,
    },
    {
      timestamp: 36.77,
    },
    {
      timestamp: 38.63,
    },
    {
      timestamp: 40.48,
    },
    {
      timestamp: 42.35,
    },
    {
      timestamp: 44.19,
    },
    {
      timestamp: 46.14,
    },
    {
      timestamp: 47.91,
    },
    {
      timestamp: 49.78,
    },
    {
      timestamp: 51.66,
    },
    {
      timestamp: 53.51,
    },
    {
      timestamp: 55.36,
    },
    {
      timestamp: 57.21,
    },
    {
      timestamp: 59.07,
    },
    {
      timestamp: 61.04,
    },
    {
      timestamp: 62.81,
    },
    {
      timestamp: 64.66,
    },
    {
      timestamp: 66.6,
    },
    {
      timestamp: 68.24,
    },
    {
      timestamp: 70.5,
    },
  ];

  // The context for the scene, this is how the app tracks what bubble should be showing and at
  // what point in the tutorial the user is.
  const [context, setContext] = useState({
    circleCount: 1,
    timingCount: -1,
    activateClickDiv: false,
    clickedOnce: false,
    showCircle1: false,
    showCircle2: false,
    showCircle3: false,
    showCircle4: false,
    timerId: 0,
    secondTimerId: 0,
    startedTutorial: false,
    finishedTutorial: false,
    startedTutorial2: false,
    finishedTutorial2: false,
  });

  // Play tutorial (music channel) when startedTutorial is set
  useEffect(() => {
    if (!context.startedTutorial) return;
    playMusicAudio(
      tutorial,
      () => {
        document.getElementsByClassName('circleDiv')[0].style.display = 'none';
        context.secondTimerId = setTimeout(() => {
          context.activateClickDiv = true;
          context.clickedOnce = false;
          setContext({ ...context });
        }, 1000);
        if( props.unit4) {
          if(tutorial !== props.tutorial1_2){
            document.getElementById('rightHand').style.display = 'block';
          }
          else{
            document.getElementById('leftHand').style.display = 'block';
          }
        }
        document.getElementsByClassName('circleDiv')[0].style.display = 'block';
        context.startedTutorial = false;
        setContext({ ...context });
      }
    );
  }, [context.startedTutorial, tutorial]);

  // Play tutorial2 (music channel) when startedTutorial2 is set
  useEffect(() => {
    if (!context.startedTutorial2) return;
    playMusicAudio(
      props.tutorial2,
      () => {
        setPlaySong(true);
      }
    );
  }, [context.startedTutorial2, props.tutorial2]);

  // Play main song (music channel) when playSong is toggled
  useEffect(() => {
    if (!playSong) return;
    playMusicAudio(
      song,
      () => {
        setPlaySong(false);
        if (context.finishedTutorial) {
          setAnimalVoice(awesomeJobAudio);
          setAnimalGif(props.awesomeJob);
          setShowAnimal(true);
          setPlayAwesomeJob(true);
        } else {
          togglePopup();
          document.getElementsByClassName('circleDiv')[0].style.display = 'none';
          document.getElementsByClassName('circleDiv')[1].style.display = 'none';
          document.getElementsByClassName('circleDiv')[2].style.display = 'none';
          document.getElementsByClassName('circleDiv')[3].style.display = 'none';
        }
      },
      () => {
        context.finishedTutorial ? StartBubbles() : props.unit4 ? StartTutorial2() : StartTutorial();
      }
    );
  }, [playSong, song]);

  const updateScore = async () => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: props.score,
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score, target: 10 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Initially starts FTB with or without the tutorial based on what day we're at
  function controllerStart() {
    if (props.module.unlockedDays.day2 || login.grade === "Teacher Account" || login.grade === "Free Play") {
      setPlayInstructions(true);
      setAnimalVoice(props.instruction);
      setAnimalGif(props.instructionGIF);
      setShowAnimal(true);
      context.finishedTutorial = true;
      setContext({ ...context });
    } else {
      setSong(props.walkthrough)
      context.startedTutorial = true;
      setContext({ ...context });
    }
  }

  // Starts the bubble'sanimation (floating up) and begins the timers that track the bubbles pop rate.
  // This doesn't continuously send the bubbles, it just starts the first timer.
  async function StartBubbles() {
    let count = 0;
    let round = 1;
    if(props.unit3 || props.unit4){
      document.getElementById('clappingCrab').style.display='block'
    }
    for (let i = 1; i < timing.length; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp) * 1000
        )
      );
      document.getElementsByClassName('animateCrabGIF')[0].style.display='none'
      document.getElementById('counting1').style.display = 'none';
      setCountingGif(null)
      await sleep(1);
      if (count === 0) {
        if((round % 2) !== 0 && props.unit4){
          document.getElementById('rightHand').style.display =
          'block';
        }
        else if ((round % 2) === 0 && props.unit4){
          document.getElementById('leftHand').style.display =
          'block';
        }
        if(!props.unit3 && !props.unit4){
          setCountingGif(props.count)
          document.getElementById('counting1').style.display = 'block';
        }
        setTimeout(() => {
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 600);
      }
      else{
        if(props.unit3 || props.unit4){
          setTimeout(() => {
            lottieRef.current.anim.goToAndPlay(0, true);
          }, 800);
        }
        else{
          setCountingGif(props.count)
          document.getElementById('counting1').style.display = 'block';
        }
      }
      if (count === 0) {
        document.getElementsByClassName('circleDiv')[3].style.display = 'none';
        context.activateClickDiv = false;
        setContext({ ...context });
      } else {
        if (count === 1) {
          if(props.unit4){
            document.getElementById('rightHand').style.display =
            'none';
            document.getElementById('leftHand').style.display =
            'none';
          }
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleDiv')[count - 1].style.display =
          'none';
      }
      document.getElementsByClassName('circleDiv')[count].style.display =
        'block';
      count += 1;
      if (count === 4) {
        round += 1;
        count = 0;
      }
    }
    document.getElementsByClassName('animateCrabGIF')[0].style.display='block'
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    if(props.unit3 || props.unit4){
      document.getElementById('clappingCrab').style.display= 'none';
      document.getElementsByClassName('circleDiv')[0].style.display = 'none';
      document.getElementById('rightHand').style.display = 'none';
      document.getElementById('leftHand').style.display = 'none';
    }
    else{
      document.getElementById('counting1').style.display = 'none';
    }
  }

  async function StartTutorial() {
    let count = 0;
    if(props.unit3 || props.unit4){
      document.getElementById('clappingCrab').style.display='block'
      document.getElementsByClassName('animateCrabGIF')[0].style.display='none'
    }
    for (let i = 1; i < 9; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp - 0.02) * 1000
        )
      );
      if (count === 0) {
        document.getElementsByClassName('circleDiv')[3].style.display = 'none';
        context.activateClickDiv = false;
        setContext({ ...context });
      } else {
        if (count === 1) {
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleDiv')[count - 1].style.display =
          'none';
      }
      document.getElementsByClassName('circleDiv')[count].style.display =
        'block';
      if (count === 0) {
        setTimeout(() => {
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 600);
      } else {
        if(props.unit3 || props.unit4){
          setTimeout(() => {
            lottieRef.current.anim.goToAndPlay(0, true);
            playSfxAudio(clappingAudio)
          }, 800);
        }
      }
      count += 1;
      if (count === 4) {
        count = 0;
      }
    }
  }

  async function StartTutorial2() {
    let count = 0;
    for (let i = 1; i < 9; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp - 0.02) * 1000
        )
      );
      if (count === 0) {
        document.getElementsByClassName('circleDiv')[3].style.display = 'none';
        context.activateClickDiv = false;
        setContext({ ...context });
      } else {
        if (count === 1) {
          document.getElementById('rightHand').style.display =
          'none';
          document.getElementById('leftHand').style.display =
          'none';
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleDiv')[count - 1].style.display =
          'none';
      }
      document.getElementsByClassName('circleDiv')[count].style.display =
        'block';
      if (count === 0) {
        if(i === 1){
          document.getElementById('rightHand').style.display =
          'block';
        }
        else{
          document.getElementById('leftHand').style.display =
          'block';
        }
        setTimeout(() => {
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 600);
      } else {
        setTimeout(() => {
          lottieRef.current.anim.goToAndPlay(0, true);
          playSfxAudio(clappingAudio)
        }, 800);
      }
      count += 1;
      if (count === 4) {
        count = 0;
      }
    }
    document.getElementById('rightHand').style.display =
    'none';
    document.getElementById('leftHand').style.display =
    'none';
  }

  async function leftrightClapping(){
    document.getElementById('clappingCrab').style.display='block'
    document.getElementsByClassName('animateCrabGIF')[0].style.display='none'
    if(tutorial !== props.tutorial1_2){
      document.getElementById('rightHand').style.display =
      'none';
    }
    else{
      document.getElementById('leftHand').style.display =
      'none';
    }
    document.getElementsByClassName('circleDiv')[1].style.display =
    'block';
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
      playSfxAudio(clappingAudio)
    }, 1000);
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    document.getElementsByClassName('circleDiv')[1].style.display =
    'none';
    document.getElementsByClassName('circleDiv')[2].style.display =
    'block';
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
      playSfxAudio(clappingAudio)
    }, 1000);
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    document.getElementsByClassName('circleDiv')[2].style.display =
    'none';
    document.getElementsByClassName('circleDiv')[3].style.display =
    'block';
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
      playSfxAudio(clappingAudio)
    }, 1000);
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    document.getElementsByClassName('circleDiv')[3].style.display =
    'none';
    if(tutorial !== props.tutorial1_2){
      setTutorial(props.tutorial1_2)
      context.startedTutorial = true;
      setContext({ ...context });
    }
    else{
      context.startedTutorial2 = true;
      setContext({ ...context });
    }
  }

  // A function that should be removed when the app is deployed, this allows us
  // as devs to skip the entirity of FTB.
  function SkipBubbles() {
    setPlaySong(false);
    if (!props.module.reviewIcon) {
      dispatch({ type: props.stepComplete, payload: 'followthebeat' });
    }
    props.setDisplayFTB(false);
  }

  // Ups the coin counter when a number 1 bubble is clicked
  function increaseCoins() {
    props.module.coins++;
  }

  // Plays the coin animation
  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
  };

  // Plays FTB twice through, then stops and moves on. Very similar to StartBubbles
  // with an end cap on it.

  // Sets a delay timer for ms milliseconds
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // Starts the application
  useEffect(() => {
    controllerStart();
  }, []);

  // ==================== iOS Detection ====================
  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  useEffect(() => {
    let timer;
    if(displayVoice && isIOS()) {
      timer = setTimeout(() => {
        setAudioReady(false);
        setDisplayVoice(false);
        setShowAnimal(false);
        if (playInstructions) {
          setPlayInstructions(false);
          //setPlaySong(true);
          togglePopup();
        }
        if (playAwesomeJob) {
          updateScore();
          if (!props.module.reviewIcon) {
            dispatch({
              type: props.stepComplete,
              payload: 'followthebeat',
            });
          }
          props.module.sectionCompleted = props.module.sectionCompleted + 1
          props.setDisplayFTB(false);
        }
      }, 10000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [displayVoice]);

  // The HTML code for FTB
  return (
    <>
      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setShowAnimal(false);
            if (playInstructions) {
              setPlayInstructions(false);
              setPlaySong(true);
            }
            if (playAwesomeJob) {
              updateScore();
              if (!props.module.reviewIcon) {
                dispatch({
                  type: props.stepComplete,
                  payload: 'followthebeat',
                });
              }
              props.module.sectionCompleted = props.module.sectionCompleted + 1
              props.setDisplayFTB(false);
            }
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}

      <div
        id='FollowTheBeatBody6'
        style={{
          backgroundImage: `url(${
            generateImageUrl('images/Module6Images/Module6Background.png')
          })`,
        }}
      >
        {(!window.location.href.includes('wearefriends.cool') ? true : window.location.href.includes('staging') ? true : false ) && <button type='button' onClick={SkipBubbles}>
          Skip The Bubbles
        </button>}
        {isOpen && (
          <PopUp
            content={
              <>
                <b id='title'>
                  Ready to begin playing?
                  <br />
                </b>
                <button
                  id='logoutButton1'
                  className='logoutButton'
                  onClick={() => {
                    document.getElementsByClassName('circleDiv')[0].style.display = 'none';
                    togglePopup();
                    setSong(props.song)
                    setPlaySong(true);
                    context.finishedTutorial = true;
                    setContext({ ...context });
                  }}
                >
                  START
                </button>
              </>
            }
            handleClose={togglePopup}
          />
        )}

        <div className='scoreBar'>
          <img className='scoreKey' src={coinBar} alt='crab Icon' />
          {props.module.coins < 10 && (
            <h5 className='scoretext1'>{props.module.coins}</h5>
          )}
          {props.module.coins >= 10 && props.module.coins < 100 && (
            <h5 className='scoretext10'>{props.module.coins}</h5>
          )}
          {props.module.coins >= 100 && (
            <h5 className='scoretext100'>{props.module.coins}</h5>
          )}
          <p className='scoretext'>100</p>
        </div>

        {showCoin && (
          <img
            id={coinAnimationState}
            className='chooseReward'
            src={coin}
            alt='reward key'
            style={{
              position: 'absolute',
              top: '40vh',
              left: '50vw',
              width: '100px',
              height: '100px',
              marginLeft: '-50px',
              marginTop: '-50px',
            }}
            onClick={() => {
              coinAnimation();
            }}
          ></img>
        )}

        <img
          className='back-btn-ftb'
          alt='back button'
          src={Exit}
          onClick={() => {
            props.setDisplayFTB(false);
          }}
        ></img>

        {(props.unit3 || props.unit4) && <div className='animateCrabFollow' id='clappingCrab' style={{display: 'none'}}>
          <LottieAnimation
            ref={lottieRef}
            jsonUrl="appfiles/greet/clapping_crab.json"
            onAnimationComplete={() => console.log('completed')}
            login={login}
          />
        </div>}
        {(
          <img className='animateCrabGIF' src={crab} alt='crab Icon' />
        )}
        {showAnimal && !audioReady && <img id='loading' src={loading} />}
        {showAnimal && (
          <img
            className='animateCrabGIF'
            alt='animation'
            style={audioReady ? { display: 'block' } : { display: 'none' }}
            onLoad={() => {
              setDisplayVoice(true);
            }}
            src={animalGif}
          />
        )}
        <img
          id='counting1'
          className='animateCrabGIF'
          src={countGif}
          style={{display: 'none', zIndex:7 }}
          alt='crab Icon'
        />
        <img className='animateFish' src={fish} alt='fish Icon' />
        <img className='animateOcto' src={octopus} alt='octopus Icon' />

        <div id='clickCircle' />
        <img src={left} id='leftHand' alt='left hand'/>
        <img src={right} id='rightHand' alt='right hand'/>
        {context.activateClickDiv ? (
          <div
            id='timedCircle'
            onClick={function () {
              playSfxAudio(poppingAudio);
              if (context.finishedTutorial) {setScore(score + 1)}
              if (context.finishedTutorial || context.startedTutorial2) {
                setCoinAnimationState('coinAnimation');
                setShowCoin(true);
                sleep(1000).then(() => {
                  setShowCoin(false);
                  increaseCoins();
                  setCoinAnimationState('');
                });
              } else {
                document.getElementsByClassName('circleDiv')[0].style.display =
                  'none';
                context.activateClickDiv = false;
                if (props.unit4){
                  leftrightClapping();
                }
                else{
                  context.startedTutorial2 = true;
                }
                setContext({ ...context });
              }
              context.activateClickDiv = false;
              setContext({ ...context });
            }}
          role='button'></div>
        ) : (
          <></>
        )}
        <div
          id='circle1'
          className='circleDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Images/Bubble1_Large%402x.png')
            })`,
          }}
        ></div>
        <div
          id='circle2'
          className='circleDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Images/Bubble2_Large%402x.png')
            })`,
          }}
        ></div>
        <div
          id='circle3'
          className='circleDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Images/Bubble3_Large%402x.png')
            })`,
          }}
        ></div>
        <div
          id='circle4'
          className='circleDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Images/Bubble4_Large+%402x.png')
            })`,
          }}
        ></div>
      </div>

      {/* Always-mounted audio elements */}
      <audio
        ref={voiceAudioRef}
        src={voiceSrc}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = voiceAudioRef.current;
          if (!el) return;
          const expected = expectedVoiceSrcRef.current;
          const currentSrc = el.currentSrc || el.src;
          if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
          if (!voiceShouldPlay) return;
          el.currentTime = 0;
          el.play().catch(() => {});
        }}
        onEnded={() => {
          const action = voiceEndActionRef.current;
          voiceEndActionRef.current = null;
          setVoiceShouldPlay(false);
          if (typeof action === 'function') action();
        }}
      />
      <audio
        ref={musicAudioRef}
        src={musicSrc}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = musicAudioRef.current;
          if (!el) return;
          if (!musicShouldPlay) return;
          el.currentTime = 0;
          el.play().then(() => {
            const onPlayAction = musicOnPlayActionRef.current;
            if (typeof onPlayAction === 'function') onPlayAction();
          }).catch(() => {});
        }}
        onEnded={() => {
          const action = musicEndActionRef.current;
          musicEndActionRef.current = null;
          setMusicShouldPlay(false);
          if (typeof action === 'function') action();
        }}
      />
      <audio
        ref={sfxAudioRef}
        src={sfxSrc}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = sfxAudioRef.current;
          if (!el) return;
          const expected = expectedSfxSrcRef.current;
          const currentSrc = el.currentSrc || el.src;
          if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
          if (!sfxShouldPlay) return;
          el.currentTime = 0;
          el.play().catch(() => {});
        }}
        onEnded={() => {
          setSfxShouldPlay(false);
        }}
      />
    </>
  );
};
export default FollowTheBeatModule6;
